import { render, staticRenderFns } from "./ForumPage.vue?vue&type=template&id=5789d65a&"
import script from "./ForumPage.vue?vue&type=script&lang=js&"
export * from "./ForumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5789d65a')) {
      api.createRecord('5789d65a', component.options)
    } else {
      api.reload('5789d65a', component.options)
    }
    module.hot.accept("./ForumPage.vue?vue&type=template&id=5789d65a&", function () {
      api.rerender('5789d65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/ForumPage.vue"
export default component.exports